import { HTMLDataTrackerProps } from '@/app/types';

export const pullDataTrackers = (
  props: HTMLDataTrackerProps & Record<string, unknown>
): HTMLDataTrackerProps => {
  const result: HTMLDataTrackerProps = {};

  if (props?.['data-tracker-type'])
    result['data-tracker-type'] = props['data-tracker-type'];

  if (props?.['data-tracker-component'])
    result['data-tracker-component'] = props['data-tracker-component'];

  if (props?.['data-tracker-section'])
    result['data-tracker-section'] = props['data-tracker-section'];

  if (props?.['data-tracker-context'])
    result['data-tracker-context'] = props['data-tracker-context'];

  return result;
};
